<template>
  <el-carousel :interval="5000" arrow="always" :height="bannerHight+'px'">
    <el-carousel-item v-for="item in srcArr" :key="item.index">
      <img :src="item.path" alt="" height="500" width="100%">
    </el-carousel-item>
  </el-carousel>
</template>
<script>
import { homeCommonData } from '@/api/frontApi/frontHome';
export default {
  data() {
    return {
      srcArr: [
        { path: '../../../../static/img/banner1.png', index: 1 }
      ],
      bannerHight: 500
    };
  },
  components: {},
  created() {
    this.getBanner();
  },
  methods: {
    getBanner() {
      // banner图片获取
      homeCommonData({ pageNo: 1, pageSize: 100, commonType: 1 }).then(res => {
        // this.firstP = res.data.records[0].commonText;
      });
    }
  }
};
</script>
<style scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/knowledge/knowBanner.vue